var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CaseCondition_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-base-pipe'; // force import for JsonSchema
import { FormulaConfig } from './formulaConfig';
const schema = {
    $id: 'urn:wisepipe-common-pipe:CaseCondition',
    type: 'object',
    properties: {
        filter: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:CompoundToolVariable'
                },
                { type: 'string', minLength: 1 }
            ]
        },
        value: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                },
                { type: 'string', minLength: 1 }
            ]
        },
        args: {
            type: 'array',
            items: {
                oneOf: [
                    {
                        $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                    },
                    { type: 'string' }
                ]
            }
        }
    },
    required: ['filter', 'value']
};
let CaseCondition = CaseCondition_1 = class CaseCondition {
    constructor(filter, value, args) {
        this.filter = filter;
        this.value = value;
        this.args = args;
        JSON.validate(this, CaseCondition_1);
    }
    static isValid(iConfigHelper, caseCondition, source) {
        return iConfigHelper.parseFormula(caseCondition.filter, source, 'boolean');
    }
    static isValidDetail(iConfigHelper, caseCondition, source) {
        return iConfigHelper.parseFormulaDetail(caseCondition.filter, source, 'boolean');
    }
    static when(iConfigHelper, caseCondition, source) {
        const result = iConfigHelper.evalSql(caseCondition.filter, FormulaConfig.PRESTO_ID_CHAR, FormulaConfig.STRING_CHAR, true, source);
        return result.formula;
    }
    static getColumnArguments(iConfigHelper, caseCondition, source) {
        const result = iConfigHelper.evalSql(caseCondition.filter, FormulaConfig.PRESTO_ID_CHAR, FormulaConfig.STRING_CHAR, true, source);
        return result.colArgs;
    }
    applyParameters(parameters) {
        const baseVals = this.getBaseValues(parameters);
        return new CaseCondition_1(baseVals.filter, baseVals.value, baseVals.args);
    }
    getBaseValues(parameters) {
        return {
            filter: parameters.getStrVal(this.filter),
            value: parameters.getStrVal(this.value),
            args: parameters.getStrArrayOrUndefVals(this.args)
        };
    }
};
CaseCondition = CaseCondition_1 = __decorate([
    JsonSchema(schema)
], CaseCondition);
export { CaseCondition };
//# sourceMappingURL=caseCondition.js.map